/* ── SmartPack Core — B2B buy block ── */
(function () {
  'use strict';

  var root = document.querySelector('[data-sp-buy]');
  if (!root || root.spBuyBound) return;
  root.spBuyBound = true;

  var DATA = {};
  try { DATA = JSON.parse(document.querySelector('[data-sp-band-data]').textContent); } catch (e) { return; }
  var BANDS = DATA.bands || [];
  if (!BANDS.length) return;

  var ONCE_STEP = 50,  ONCE_MIN = 50;
  var SUB_STEP  = 500, SUB_MIN  = 500;
  function syncRulesFromEngine() {
    var p = window.SPPricing;
    if (!p) return;
    ONCE_STEP = p.ONCE_STEP; ONCE_MIN = p.ONCE_MIN;
    SUB_STEP  = p.SUB_STEP;  SUB_MIN  = p.SUB_MIN;
  }
  var DEFAULT_QTY = ONCE_MIN;

  var el = {
    unit:      root.querySelector('[data-sp-b2b-price]'),
    was:       root.querySelector('[data-sp-was]'),
    wasWrap:   root.querySelector('[data-sp-wasw]'),
    sub:       root.querySelector('[data-sp-pricesub]'),
    qty:       root.querySelector('[data-sp-quantity-input]'),
    qtyRaw:    root.querySelector('[data-sp-qty-raw]'),
    qtyLabel:  root.querySelector('[data-sp-qty-label]'),
    wasLbl:    root.querySelector('[data-sp-waslbl]'),
    summary:   root.querySelector('[data-sp-summary]'),
    ladder:    root.querySelector('[data-sp-ladder]'),
    ladderSect:root.querySelector('[data-sp-ladder-sect]'),
    ladderBody:root.querySelector('[data-sp-ladder-body]'),
    ladderMore:root.querySelector('[data-sp-ladder-more]'),
    schedSel:  root.querySelector('[data-sp-sched-select]'),
    schedSect: root.querySelector('[data-sp-sched-sect]'),
    tierPill:  root.querySelector('[data-sp-tierpill]'),
    tierShort: root.querySelector('[data-sp-tiershort]'),
    tierWrap:  root.querySelector('[data-sp-tierwrap]'),
    top:       root.querySelector('[data-sp-top]'),
    swAr:      root.querySelector('[data-sp-switch="blanket"]'),
    swOnce:    root.querySelector('[data-sp-switch="once"]'),
    swSubAr:   root.querySelector('[data-sp-switch-sub="blanket"]'),
    swSubOnce: root.querySelector('[data-sp-switch-sub="once"]'),
    quote:     root.querySelector('[data-sp-quote]'),
    quoteLead: root.querySelector('[data-sp-quote-lead]'),
    how:       root.querySelector('[data-sp-how-open]')
  };

  var AR_CTA = 'Customize & Start Auto Reorder';

  function money(c) { var p = P(); return p ? p.money(c) : ''; }
  function num(n)   { var p = P(); return p ? p.num(n) : String(n); }

  /* ── Appstle bridge ── */
  function appstleRadios() {
    return {
      once: document.querySelector('.appstle_one_time_details_wrapper input[name="selling_plan"]'),
      sub:  document.querySelector('.appstle_subscription_radio_wrapper input[name="selling_plan"]')
    };
  }
  function appstleSelect() {
    return document.querySelector('#appstle_subscription_dropdown, .appstle_subscription_wrapper select');
  }
  function currentPlanId() {
    var checked = document.querySelector('input[name="selling_plan"]:checked');
    if (!checked || !checked.value) return '';
    var sel = appstleSelect();
    if (sel && sel.value) return sel.value;
    return checked.value;
  }
  function isBlanket() { return !!currentPlanId(); }

  var DEFAULT_PLAN = '703437340985';
  var schedTouched = false;
  function applyDefaultSchedule() {
    if (schedTouched) return;
    var sel = appstleSelect();
    if (!sel || sel.value === DEFAULT_PLAN) return;
    var has = Array.prototype.some.call(sel.options, function (o) { return o.value === DEFAULT_PLAN; });
    if (!has) return;
    sel.value = DEFAULT_PLAN;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var PER_YEAR = {
    '703437373753': 26, '703437340985': 12, '703437406521': 6,
    '703437439289': 4,  '703437472057': 2
  };
  function perYear(planId) { return PER_YEAR[String(planId)] || 1; }

  var PLAN_MONTHS = {
    '703437373753': 0,
    '703437340985': 1, '703437406521': 2, '703437439289': 3, '703437472057': 6
  };

  function ordinal(d) {
    var s = ['th', 'st', 'nd', 'rd'], v = d % 100;
    return d + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function shipsLabel(planId) {
    var months = PLAN_MONTHS[String(planId)];
    if (months === undefined) return 'On your chosen schedule';
    var every = months === 1 ? 'Every month' : 'Every ' + months + ' months';
    if (!months) return 'Every 2 weeks';

    var day = new Date().getDate();
    if (day > 28) return every;
    return every + ', on the ' + ordinal(day);
  }

  var FREE_SHIP_OVER = 19900;

  var PROD_TIERS = [
    { upTo: 2500,     label: '3–5' },
    { upTo: 10000,    label: '5–7' },
    { upTo: Infinity, label: '7–14' }
  ];
  function prodLabel(qty) {
    for (var i = 0; i < PROD_TIERS.length; i++) if (qty <= PROD_TIERS[i].upTo) return PROD_TIERS[i].label;
    return PROD_TIERS[PROD_TIERS.length - 1].label;
  }

  function P() { return window.SPPricing || null; }

  function blanketCents(baseCents, freqKeys)     { var p = P(); return p ? p.blanketCents(baseCents, freqKeys) : null; }
  function blanketBandFor(annual)                { var p = P(); return p ? p.blanketBandFor(DATA, annual) : null; }
  function blanketUnitFor(qtyPerRelease, planId) { var p = P(); return p ? p.blanketUnitFor(DATA, qtyPerRelease, planId) : null; }
  function bestBlanketFor(qtyPerRelease)         { var p = P(); return p ? p.bestBlanketFor(DATA, qtyPerRelease) : null; }
  function lowestBlanket()                       { var p = P(); return p ? p.lowestBlanket(DATA) : null; }
  function blanketLadder(planId)                 { var p = P(); return p ? p.blanketLadder(DATA, planId) : []; }

  var LADDER_WINDOW = 4;
  var LADDER_FULL_MAX = 4;
  var ladderExpanded = false;

  function onceLadder() {
    var p = P(); if (!p) return [];
    return p.onceLadder(DATA);
  }

  function selectedIndex(tiers, qty) { var p = P(); return p ? p.selectedIndex(tiers, qty) : 0; }

  var ladderCap = null;
  function tierLabel(tiers, i) { var p = P(); return p ? p.tierLabel(tiers, i, ladderCap) : ''; }

  var ladderQuoteCap = null, ladderQuoteBlanket = false;
  function quoteRow(blanket) {
    var label = blanket ? 'over ' + num(ladderQuoteCap) + '/yr' : num(ladderQuoteCap + 1) + '+';
    return '<tr class="sp-ladder__quote" aria-disabled="true">' +
           '<td>' + label + '</td><td><span class="sp-ladder__q">by quote</span></td></tr>';
  }

  function tierRow(tiers, i, isSelected) {
    var price = money(tiers[i].cents);
    return '<tr data-band-min="' + tiers[i].min + '" tabindex="0" role="button"' +
           (isSelected ? ' class="is-active" aria-current="true"' : '') + '>' +
           '<td>' + tierLabel(tiers, i) + '</td><td>' + price + '</td></tr>';
  }

  function ladderHtml(tiers, qty) {
    var N = tiers.length;
    if (!N) return '';
    var S = qty >= tiers[0].min ? selectedIndex(tiers, qty) : -1;
    var floor = N - 1;
    var html = '', i, from = 0, to = N - 1;

    if (!ladderExpanded && N > LADDER_FULL_MAX) {
      from = Math.min(Math.max(S - 1, 0), N - LADDER_WINDOW);
      to = from + LADDER_WINDOW - 1;
    }
    for (i = from; i <= to; i++) html += tierRow(tiers, i, i === S);
    if (ladderQuoteCap && to === floor && (ladderExpanded || N <= LADDER_FULL_MAX)) html += quoteRow(ladderQuoteBlanket);
    return html;
  }

  function paintLadder(blanket, planId, qty) {
    if (!el.ladderBody) return;
    ladderCap = blanket ? null : (DATA.onceCap || null);
    ladderQuoteCap = blanket ? (DATA.arCap || null) : (DATA.onceCap || null);
    ladderQuoteBlanket = blanket;
    var tiers;
    if (blanket) {
      tiers = blanketLadder(planId);
      if (!tiers.length) { if (el.ladderSect) el.ladderSect.hidden = true; return; }
    } else {
      tiers = onceLadder();
    }

    el.ladderBody.innerHTML = ladderHtml(tiers, qty);

    if (el.ladderMore) {
      var windowed = tiers.length > LADDER_FULL_MAX;
      el.ladderMore.hidden = !windowed;
      if (windowed) {
        el.ladderMore.textContent = ladderExpanded
          ? 'Show fewer tiers'
          : 'View All Price Breaks – as low as ' +
            money(tiers[tiers.length - 1].cents) + '/pc';
        el.ladderMore.setAttribute('aria-expanded', String(ladderExpanded));
      }
    }
  }

  /* ── Band maths ── */
  function bandFor(q) {
    var found = null;
    for (var i = 0; i < BANDS.length; i++) if (q >= BANDS[i].min) found = BANDS[i];
    return found;
  }

  /* ── Quantity ── */
  function parseQty(s) { return parseInt(String(s).replace(/[^0-9]/g, ''), 10) || 0; }
  function currentQty() { return el.qtyRaw ? (parseInt(el.qtyRaw.value, 10) || 0) : parseQty(el.qty.value); }
  function rules() {
    return isBlanket() ? { step: SUB_STEP, min: SUB_MIN } : { step: ONCE_STEP, min: ONCE_MIN };
  }
  function snap(n) {
    var r = rules();
    return Math.max(r.min, Math.round(n / r.step) * r.step);
  }
  function setQty(n, skipFormat) {
    var v = Math.max(0, Math.round(n));
    if (el.qtyRaw) el.qtyRaw.value = String(v);
    if (!skipFormat) el.qty.value = num(v);
    render();
    if (el.qtyRaw) el.qtyRaw.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ── Render ── */
  var arScheme = root.getAttribute('data-sp-ar-scheme') || '';
  function paintScheme(blanket) {
    if (!arScheme) return;
    if (el.top) el.top.classList.toggle(arScheme, blanket);
    if (el.schedSect) el.schedSect.classList.toggle(arScheme, blanket);
  }
  var ctaOnce = null;
  function paintCta(blanket) {
    var btn = document.getElementById('qstomizer-product-button');
    if (!btn) return;
    var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null, false), t, node = null;
    while ((t = w.nextNode())) { if (t.nodeValue.trim()) { node = t; break; } }
    if (!node) return;
    if (ctaOnce === null && node.nodeValue.trim() !== AR_CTA) ctaOnce = node.nodeValue;
    if (ctaOnce === null) return;
    var want = blanket ? AR_CTA : ctaOnce;
    if (node.nodeValue !== want) node.nodeValue = want;
  }

  function render() {
    if (!P()) { setTimeout(render, 60); return; }
    syncRulesFromEngine();
    var blanket = isBlanket();
    var qty = currentQty();
    var planId = currentPlanId();
    var annual = blanket ? qty * perYear(planId) : qty;

    var band = bandFor(annual);
    var onceBand = bandFor(qty) || { cents: DATA.list };
    var unitCents = band ? band.cents : DATA.list;
    var blanketUnit = blanket ? blanketUnitFor(qty, planId) : null;

    var quote = blanket ? !!(DATA.arCap && annual > DATA.arCap)
                        : !!(DATA.onceCap && qty > DATA.onceCap);
    if (quote) { band = null; unitCents = DATA.list; blanketUnit = DATA.list; }
    setQuoteState(quote, blanket, qty, annual);

    paintScheme(blanket);
    paintCta(blanket);
    if (el.schedSect) el.schedSect.hidden = !blanket;
    if (el.ladderSect) el.ladderSect.hidden = false;
    paintLadder(blanket, planId, qty);

    if (el.schedSel && blanket && planId && el.schedSel.value !== String(planId)) {
      el.schedSel.value = String(planId);
    }
    root.classList.toggle('is-blanket', blanket);

    if (el.qtyLabel) {
      el.qtyLabel.innerHTML = blanket
        ? 'Quantity<span class="sp-stepper__label-long"> per release</span>'
        : 'Quantity';
    }
    if (el.qty) el.qty.setAttribute('aria-label', blanket ? 'Quantity per release' : 'Quantity');

    if (el.unit) {
      el.unit.textContent = blanket ? (blanketUnit ? money(blanketUnit) : '—')
                                    : money(unitCents);
    }
    var oneC = onceBand.cents || DATA.list;
    if (el.was) {
      el.was.textContent = money(blanket ? oneC : DATA.list);
      if (el.wasLbl) el.wasLbl.textContent = blanket ? 'buy once' : 'list';
      (el.wasWrap || el.was).hidden = quote || (blanket ? !(blanketUnit && oneC > blanketUnit) : !band);
    }
    var tierOn = !blanket && DATA.tierPct > 0;
    if (el.tierPill) el.tierPill.textContent = '\u2014 ' + DATA.tierPct + '% comes off at checkout';
    if (el.tierShort) el.tierShort.textContent = 'Reseller \u2014 ' + DATA.tierPct + '% off';
    if (el.tierWrap) el.tierWrap.hidden = !tierOn;
    root.classList.toggle('has-tier', tierOn);

    if (el.sub) {
      if (quote) {
        el.sub.innerHTML = blanket
          ? 'Above <b>' + num(DATA.arCap) + ' pieces a year</b> this is list price — ask us and we will do better.'
          : 'Above <b>' + num(DATA.onceCap) + ' pieces</b> this is list price — ask us and we will do better.';
      } else if (blanket) {
        if (blanketUnit && annual) {
          var arPct = oneC > blanketUnit ? Math.round((1 - blanketUnit / oneC) * 100) : 0;
          el.sub.innerHTML =
            '<span class="sp-buy__sub-long">That\u2019s <b>' + num(annual) + ' pieces</b> a year, shipped <b>' +
            num(qty) + '</b> at a time — </span><b>' +
            money(blanketUnit * qty) + '</b> per shipment' +
            (arPct > 0 ? ', <b>' + arPct + '% less</b> than buying ' + num(qty) + ' once.' : '.');
        } else {
          el.sub.innerHTML = 'Choose at least ' + num(SUB_MIN) + ' pieces per release.';
        }
      } else {
        el.sub.innerHTML = band
          ? 'Your price at <b>' + num(qty) + ' pieces</b> — <b>' + money(qty * unitCents) + '</b> total.'
          : 'Price breaks start at ' + num(BANDS[0].min) + ' pieces.';
      }
    }

    document.documentElement.classList.toggle('sp-is-blanket', blanket);
    if (el.how) el.how.hidden = quote || !blanket;
    if (el.swAr && el.swOnce) {
      var bestC = null, bestPid = null, arQty = Math.max(qty, SUB_MIN);
      if (!blanket) {
        Object.keys(PER_YEAR).forEach(function (pid) {
          var c = blanketUnitFor(arQty, pid);
          if (c !== null && (bestC === null || c < bestC)) { bestC = c; bestPid = pid; }
        });
      }
      el.swAr.classList.toggle('is-active', blanket);
      el.swOnce.classList.toggle('is-active', !blanket);
      el.swAr.setAttribute('aria-pressed', String(blanket));
      el.swOnce.setAttribute('aria-pressed', String(!blanket));
      el.swAr.setAttribute('data-sp-switch-plan', bestPid || '');
      if (el.swSubOnce) {
        el.swSubOnce.innerHTML = blanket
          ? '<b>' + num(qty) + ' pieces</b> at <b>' + money(oneC) + '/pc</b>'
          : money(unitCents) + '/pc';
      }
      var promoPrice = document.querySelector('[data-sp-arpromo-price]'), promoOnce = document.querySelector('[data-sp-arpromo-once]');
      if (promoPrice) {
        var pc = blanket ? blanketUnit : bestC;
        promoPrice.textContent = pc ? money(pc) : '\u2014';
        if (promoOnce) promoOnce.textContent = money(blanket ? oneC : (bandFor(arQty) || { cents: DATA.list }).cents) + '/pc';
        var promoQty = document.querySelector('[data-sp-arpromo-qty]');
        if (promoQty) promoQty.textContent = 'at ' + num(blanket ? qty : arQty) + ' pieces';
      }
      if (el.swSubAr) {
        if (blanket) {
          el.swSubAr.innerHTML = blanketUnit ? money(blanketUnit) + '/pc' : '—';
        } else if (bestC !== null && qty >= SUB_MIN) {
          el.swSubAr.innerHTML = 'Same <b>' + num(qty) + ' pieces</b> for <b>' + money(bestC) + '/pc</b>';
        } else if (bestC !== null) {
          el.swSubAr.innerHTML = '<b>' + num(SUB_MIN) + ' pieces</b> for only <b>' + money(bestC) + '/pc</b>';
        } else {
          el.swSubAr.innerHTML = '';
        }
      }
    }

    if (el.summary) {
      function row(dt, dd, mod) {
        return '<div class="sp-buy__sumrow' + (mod ? ' sp-buy__sumrow--' + mod : '') + '">' +
               '<dt>' + dt + '</dt><dd>' + dd + '</dd></div>';
      }
      function shipRow(dueCents) {
        return (FREE_SHIP_OVER && dueCents >= FREE_SHIP_OVER)
          ? 'Free'
          : 'Calculated at checkout · free over $' + num(FREE_SHIP_OVER / 100);
      }
      function sumQty() {
        return '<span class="sp-buy__sumqty-full"><span class="sp-stepper sp-stepper--sm sp-stepper--mini">' +
          '<span class="sp-stepper__label">Quantity</span>' +
          '<button type="button" data-sp-sum-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="text" inputmode="numeric" autocomplete="off" value="' + num(qty) + '" data-sp-sum-qty aria-label="Quantity">' +
          '<button type="button" data-sp-sum-step="1" aria-label="Increase quantity">+</button>' +
          '</span></span>' +
          '<span class="sp-buy__sumqty-plain">' + num(qty) + ' pieces</span>';
      }

      if (!qty || (blanket && !blanketUnit)) {
        el.summary.hidden = true;
      } else if (blanket) {
        var perShip = qty * blanketUnit;
        el.summary.innerHTML = '<dl>' +
          row(sumQty(), money(perShip)) +
          row('Annual quantity', num(annual) + ' pieces') +
          row('Shipping', shipRow(perShip)) +
          row('Reorder schedule', shipsLabel(planId)) +
          row('Per shipment total', money(perShip), 'total') +
          '</dl>';
        el.summary.hidden = false;
      } else {
        var total = qty * unitCents;
        var off = 0;
        if (DATA.tierPct > 0) {
          off = Math.floor(total * DATA.tierPct / 100);
        }
        var due = total - off;

        var html = '<dl>' +
          row(sumQty(), money(total)) +
          (off ? row('Your ' + DATA.tierPct + '% reseller discount', '−' + money(off), 'save') : '') +
          row('Shipping', shipRow(due)) +
          row('Estimated ship date', prodLabel(qty) + ' business days') +
          row('Order total', money(due), 'total') +
          '</dl>';

        el.summary.innerHTML = html;
        el.summary.hidden = false;
      }
    }
  }

  var quoteState = false;
  function setQuoteState(on, blanket, qty, annual) {
    root.classList.toggle('is-quote', on);
    if (el.quote) el.quote.hidden = !on;
    if (on && el.quoteLead) {
      el.quoteLead.textContent = blanket
        ? num(qty) + ' per release is ' + num(annual) + ' pieces a year — more than we price online.'
        : num(qty) + ' pieces is more than we price online.';
    }
    if (on !== quoteState) {
      quoteState = on;
      root.dispatchEvent(new CustomEvent('sp:quote-state', {
        bubbles: true, detail: { quote: on, blanket: blanket, qty: qty, annual: annual }
      }));
    }
  }

  /* ── Wiring ── */
  function setMode(mode) {
    var r = appstleRadios();
    var target = mode === 'blanket' ? r.sub : r.once;
    if (target && !target.checked) target.click();
    if (mode === 'blanket') setTimeout(applyDefaultSchedule, 350);
    setTimeout(function () { setQty(snap(currentQty())); }, 350);
    render();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sp-switch]');
    if (!b || b.classList.contains('is-active')) return;
    var to = b.getAttribute('data-sp-switch');
    var plan = b.getAttribute('data-sp-switch-plan');
    setMode(to);
    if (to === 'blanket' && plan) {
      schedTouched = true;
      setTimeout(function () {
        var sel = appstleSelect();
        if (sel && sel.value !== plan) { sel.value = plan; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        if (el.schedSel) el.schedSel.value = plan;
        setTimeout(function () { setQty(snap(currentQty())); }, 250);
      }, 400);
    }
  });

  if (el.schedSel) {
    el.schedSel.addEventListener('change', function () {
      schedTouched = true;
      var sel = appstleSelect();
      if (sel) { sel.value = el.schedSel.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      setTimeout(function () { setQty(snap(currentQty())); }, 250);
    });
  }

  root.querySelectorAll('[data-sp-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dir = parseInt(b.getAttribute('data-sp-qty-step'), 10);
      var r = rules();
      setQty(Math.max(r.min, currentQty() + dir * r.step));
    });
  });

  el.qty.addEventListener('input', function () {
    if (el.qtyRaw) el.qtyRaw.value = String(parseQty(el.qty.value));
    render();
  });
  el.qty.addEventListener('blur', function () { setQty(snap(parseQty(el.qty.value))); });
  el.qty.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); setQty(snap(parseQty(el.qty.value))); el.qty.blur(); }
  });

  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sp-sum-step]');
    if (!b) return;
    var dir = parseInt(b.getAttribute('data-sp-sum-step'), 10);
    var r = rules();
    setQty(Math.max(r.min, currentQty() + dir * r.step));
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-sp-sum-qty]')) setQty(snap(parseQty(t.value)));
  });
  root.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.matches && t.matches('[data-sp-sum-qty]')) { e.preventDefault(); t.blur(); }
  });

  if (el.ladder) {
    function pickRow(t) {
      var r = t && t.closest ? t.closest('[data-band-min]') : null;
      if (!r) return false;
      setQty(snap(parseInt(r.getAttribute('data-band-min'), 10)));
      return true;
    }
    el.ladder.addEventListener('click', function (e) { pickRow(e.target); });
    el.ladder.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (pickRow(e.target)) e.preventDefault();
    });
  }

  if (el.ladderMore) {
    el.ladderMore.addEventListener('click', function () {
      ladderExpanded = !ladderExpanded;
      render();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches &&
        e.target.matches('input[name="selling_plan"], select[name="selling_plan"], #appstle_subscription_dropdown')) {
      setTimeout(function () { setQty(snap(currentQty())); }, 150);
    }
  });

  function collapseAppstleHost() {
    var w = document.querySelector('.appstle_sub_widget, #appstle_subscription_widget0');
    var host = w && w.closest ? w.closest('.sp-product__block') : null;
    if (!host || host.hasAttribute('data-sp-collapsed')) return;
    if (host.contains(root)) return;
    host.setAttribute('data-sp-collapsed', '');
    host.style.cssText += ';position:absolute;width:1px;height:1px;overflow:hidden;' +
      'clip:rect(0 0 0 0);margin:0;padding:0;pointer-events:none;';
  }
  collapseAppstleHost();

  function adoptCustomizeButton() {
    var slot = root.querySelector('[data-sp-customize-slot]');
    var btn = document.getElementById('qstomizer-product-button');
    if (!slot || !btn) return;
    if (btn.parentNode !== slot) slot.appendChild(btn);
    unescapeAmp(btn);
    paintCta(isBlanket());
  }
  function unescapeAmp(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), t;
    while ((t = w.nextNode())) {
      if (t.nodeValue.indexOf('&amp;') !== -1) t.nodeValue = t.nodeValue.replace(/&amp;/g, '&');
    }
  }

  adoptCustomizeButton();

  if (window.MutationObserver) {
    new MutationObserver(function () { adoptCustomizeButton(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  var tries = 0;
  var poll = setInterval(function () {
    collapseAppstleHost();
    adoptCustomizeButton();
    render();
    if (++tries > 40 || document.querySelector('input[name="selling_plan"]')) clearInterval(poll);
  }, 250);

  /* ── Modals: how it works + terms gate ── */
  var EXAMPLE_QTY = 5000;
  var PLAN_WORD = {
    '703437373753': '2 weeks', '703437340985': 'month', '703437406521': '2 months',
    '703437439289': 'quarter', '703437472057': '6 months'
  };
  function planWord(pid) { return PLAN_WORD[String(pid)] || 'schedule'; }
  function activePlan() { return currentPlanId() || (schedTouched && el.schedSel ? el.schedSel.value : DEFAULT_PLAN); }
  function onceCents(q) { var b = bandFor(q); return b ? b.cents : DATA.list; }
  function pctLess(once, ar) { return once > ar ? Math.round((1 - ar / once) * 100) : 0; }

  var modals = {}, modalOpener = null;
  Array.prototype.forEach.call(root.querySelectorAll('[data-sp-modal]'), function (m) {
    modals[m.getAttribute('data-sp-modal')] = m;
    document.body.appendChild(m);
  });
  function openModal(name, opener) {
    var m = modals[name]; if (!m) return;
    modalOpener = opener || document.activeElement;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = m.querySelector('.sp-buy-modal__dialog .sp-btn:not([disabled]), .sp-buy-modal__dialog input');
    if (first) first.focus();
  }
  function closeModal(name) {
    var m = modals[name]; if (!m || m.hidden) return;
    m.hidden = true;
    document.body.style.overflow = '';
    if (modalOpener && modalOpener.focus) modalOpener.focus();
    modalOpener = null;
  }
  function openName() { for (var k in modals) if (!modals[k].hidden) return k; return null; }
  function text(m, sel, v) { var n = m.querySelector(sel); if (n) n.innerHTML = v; }

  function fillHow() {
    var m = modals.how; if (!m) return;
    var pid = activePlan(), per = perYear(pid), word = planWord(pid);
    var ex = EXAMPLE_QTY, arC = blanketUnitFor(ex, pid);
    if (arC === null) { ex = Math.max(snap(currentQty()), SUB_MIN); arC = blanketUnitFor(ex, pid); }
    var onceC = onceCents(ex), annual = ex * per;
    var qty = Math.max(currentQty(), SUB_MIN);
    text(m, '[data-sp-how-kicker]', 'You\u2019re looking at ' + num(qty) + ' pieces, every ' + word);
    text(m, '[data-sp-how-once-price]', money(onceC));
    text(m, '[data-sp-how-once-cap]', num(ex) + ' pieces, one time');
    text(m, '[data-sp-how-ar-price]', arC !== null ? money(arC) : '\u2014');
    text(m, '[data-sp-how-ar-cap]', num(ex) + ' a ' + word + ' \u00b7 ' + num(annual) + ' a year');
    text(m, '[data-sp-how-qty]', num(ex));
    var pct = arC !== null ? pctLess(onceC, arC) : 0;
    text(m, '[data-sp-how-step1]', 'Ordering ' + num(ex) + ' once puts you in the ' + num(ex) + '-piece price break. Ordering ' + num(ex) +
      ' every ' + word + ' means you buy <strong>' + num(annual) + ' in a year</strong> \u2014 so we give you the ' + num(annual) + '-piece price on every shipment' +
      (pct ? ', <strong>' + pct + '% less</strong> per piece.' : '.'));
  }

  function fillGate() {
    var m = modals.gate; if (!m) return;
    var pid = activePlan(), per = perYear(pid), word = planWord(pid);
    var qty = Math.max(snap(currentQty()), SUB_MIN), annual = qty * per;
    var arC = blanketUnitFor(qty, pid), onceC = onceCents(qty);
    var price = arC !== null ? money(arC) + '/pc' : 'list price';
    text(m, '[data-sp-gate-qty]', num(qty) + ' pieces');
    text(m, '[data-sp-gate-ships]', 'Every ' + (word === 'month' ? 'month' : word === 'quarter' ? '3 months' : word));
    text(m, '[data-sp-gate-price-row]', price);
    text(m, '[data-sp-gate-once-row]', money(onceC) + '/pc');
    text(m, '[data-sp-gate-annual-row]', num(annual) + ' pieces');
    text(m, '[data-sp-gate-total]', arC !== null ? money(arC * qty) : '\u2014');
    text(m, '[data-sp-gate-word]', word);
    text(m, '[data-sp-gate-price]', price);
    var chk = m.querySelector('[data-sp-gate-check]'), go = m.querySelector('[data-sp-gate-go]');
    if (chk) chk.checked = false;
    if (go) { go.disabled = true; go.classList.remove('sp-btn--shimmer'); }
  }

  function openChat() {
    var title = root.getAttribute('data-sp-product-title') || document.title;
    var pid = activePlan();
    var msg = 'Hi! I have a question about Auto Reorder for the ' + title + ' \u2014 ' + num(Math.max(currentQty(), SUB_MIN)) + ' pieces every ' + planWord(pid) + '.';
    var z = window.$zoho && window.$zoho.salesiq;
    if (z && z.visitor && z.floatwindow) {
      try { z.visitor.question(msg); z.floatwindow.visible('show'); return; } catch (e) {}
    }
    window.location.href = '/pages/contact';
  }

  var gateBypass = false;
  var customizeBtn = function () { return document.getElementById('qstomizer-product-button'); };
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t;
    if ((t = e.target.closest('[data-sp-how-open]'))) { fillHow(); openModal('how', t); return; }
    if ((t = e.target.closest('[data-sp-how-chat]'))) { e.preventDefault(); openChat(); return; }
    if ((t = e.target.closest('[data-sp-how-start]'))) {
      closeModal('how');
      if (!isBlanket() && el.swAr) el.swAr.click();
      var qs = el.qty.closest('.sp-buy__sect') || el.qty;
      qs.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(function () { el.qty.focus(); el.qty.select(); }, 450);
      return;
    }
    if ((t = e.target.closest('[data-sp-gate-go]'))) {
      if (t.disabled) return;
      closeModal('gate');
      var btn = customizeBtn();
      if (!btn) return;
      gateBypass = true;
      btn.click();
      gateBypass = false;
      return;
    }
    if ((t = e.target.closest('[data-sp-modal-close]'))) { var mm = t.closest('[data-sp-modal]'); if (mm) closeModal(mm.getAttribute('data-sp-modal')); }
  });
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-sp-gate-check]')) return;
    var go = modals.gate && modals.gate.querySelector('[data-sp-gate-go]');
    if (!go) return;
    go.disabled = !e.target.checked;
    go.classList.toggle('sp-btn--shimmer', e.target.checked);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var n = openName(); if (n) closeModal(n);
  });
  window.addEventListener('click', function (e) {
    if (gateBypass || !isBlanket() || !modals.gate) return;
    var t = e.target && e.target.closest && e.target.closest('#qstomizer-product-button');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fillGate();
    openModal('gate', t);
  }, true);

  var P_QTY = 0, P_MODE = '';
  try {
    var spParams = new URLSearchParams(window.location.search);
    P_QTY = parseInt(spParams.get('qty'), 10) || 0;
    P_MODE = spParams.get('mode') || '';
  } catch (e) {}

  function clampNote(req, applied) {
    var sect = el.qty && el.qty.closest('.sp-buy__sect');
    if (!sect) return;
    var n = document.createElement('p');
    n.className = 'sp-buy__note';
    n.textContent = 'Quantity adjusted from ' + num(req) + ' to ' + num(applied) +
      ' to fit this product’s ordering options.';
    sect.appendChild(n);
  }

  function bootQty() {
    if (P_QTY > 0) {
      var s = snap(P_QTY);
      setQty(s);
      if (s !== P_QTY) clampNote(P_QTY, s);
    } else {
      setQty(DEFAULT_QTY);
    }
  }

  if (P_MODE === 'auto-reorder') {
    setQty(P_QTY > 0 ? P_QTY : DEFAULT_QTY);
    var mtries = 0;
    var mpoll = setInterval(function () {
      var mr = appstleRadios();
      if (mr.sub) {
        clearInterval(mpoll);
        setMode('blanket');
        setTimeout(bootQty, 700);
      } else if (++mtries > 40) {
        clearInterval(mpoll);
        bootQty();
      }
    }, 250);
  } else {
    bootQty();
  }
})();
